export default __webpack_public_path__ + "navigation-examples-advanced-v1-960-3d01a46ce49816b18e06f9ec25a0e284.webp";